// extracted by mini-css-extract-plugin
export default {"wrapper":"body_wrapper__ajgmZ","content":"body_content__4LVuh"};